<div
   *ngIf="isConfirmLoading"
   [froalaEditor]="options"
   [(froalaModel)]="content"
   class="rtEditor"></div>
